import React from 'react';

import { Tour as TourCore, TourProps } from 'antd';

interface ITourProps extends TourProps {}

/**
 *
 * @description UI component for Tour
 *
 * @author  Rohit Niraj Singh <@rohit.singh3>
 *
 * @returns {React.ReactElement}
 */

export default function Tour(props: ITourProps) {
	return <TourCore {...props} />;
}
